import {api} from "../../config/api";
import secureStorage from "../../utils/secureStorage";

// Loyalty program + cards — clicoo LoyaltyController (/api/loyalty/*).

export const LOYALTY_MODES = {
    off: "Désactivé",
    points: "Points",
    remise: "Remise",
};

export const CARD_STATUS_LABELS = {
    active: "Active",
    blocked: "Bloquée",
    replaced: "Remplacée",
};

const headers = async () => {
    const account = await secureStorage.getItem("selectedAccount");
    return {"X-account-id": account?.id, Accept: "application/json"};
};

// Error message sent by the API ({error}), or a generic fallback.
export const apiErrorMessage = (error, fallback) =>
    error?.response?.data?.error || error?.response?.data?.detail || fallback;

export const fetchLoyaltyProgram = async () => {
    const {data} = await api.get("/loyalty/program", {headers: await headers()});
    return data;
};

export const updateLoyaltyProgram = async (program) => {
    const {data} = await api.put("/loyalty/program", program, {headers: await headers()});
    return data;
};

export const fetchLoyaltyCards = async ({page = 1, itemsPerPage = 20, search = "", status = ""}) => {
    const params = new URLSearchParams({page, itemsPerPage});
    if (search) params.set("search", search);
    if (status) params.set("status", status);
    const {data} = await api.get(`/loyalty/cards?${params.toString()}`, {headers: await headers()});
    return data;
};

export const fetchClientLoyaltyCards = async (clientId) => {
    const {data} = await api.get(`/loyalty/clients/${clientId}/cards`, {headers: await headers()});
    return data;
};

export const createLoyaltyCard = async (clientId) => {
    const {data} = await api.post("/loyalty/cards", {client_id: clientId}, {headers: await headers()});
    return data;
};

export const replaceLoyaltyCard = async (cardId) => {
    const {data} = await api.post(`/loyalty/cards/${cardId}/replace`, {}, {headers: await headers()});
    return data;
};

export const setLoyaltyCardBlocked = async (cardId, blocked) => {
    const action = blocked ? "block" : "unblock";
    const {data} = await api.post(`/loyalty/cards/${cardId}/${action}`, {}, {headers: await headers()});
    return data;
};

export const generateMissingLoyaltyCards = async () => {
    const {data} = await api.post("/loyalty/cards/generate-missing", {}, {headers: await headers()});
    return data;
};

// Discounts of the account, for the "remise" mode picker.
export const fetchDiscountOptions = async () => {
    const {data} = await api.get("/discounts?page=1&itemsPerPage=100", {headers: await headers()});
    return (data?.data || []).map((d) => ({
        id: d.id,
        // discounts.type is "%" or "DH" (NewRemiseForm).
        name: d.value != null ? `${d.name} (${d.value} ${d.type || "%"})` : d.name,
    }));
};
